const FONT_WEIGHT_BOLD = 700;

export const getStyles = ({ palette }) => {
  const isDarkTheme = palette.type === 'dark';

  return {
    root: {
      color: palette.text.primary,
      backgroundColor: 'transparent',
    },
    content: {
      transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      flexDirection: 'row',
      backgroundColor: 'transparent',
      padding: 0,
      gap: 0,
      '&:hover': {
        backgroundColor: isDarkTheme ? '#383838' : palette.action.hover,
      },
    },
    group: {
      marginLeft: '0',
    },
    label: {
      paddingLeft: 0,
      backgroundColor: 'unset !important',
      fontWeight: FONT_WEIGHT_BOLD,
      '& > *': {
        paddingLeft: '10px',
        paddingRight: '10px',
      },
    },
    iconContainer: {
      width: 'auto',
      marginRight: '4px',
      zIndex: '9',
      '&:hover': {
        backgroundColor: 'unset !important',
      },
    },
    category: {
      justifyContent: 'space-between',
      paddingTop: '4px',
      paddingBottom: '4px',
      '&:hover': {
        backgroundColor: 'unset !important',
      },
    },
    nameContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    name: {
      flex: 1,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      paddingRight: '30px',
      maxWidth: '200px',
    },
    counter: {
      fontSize: '12px',
      borderRadius: '10px',
      backgroundColor: palette.background.disabled,
      color: palette.text.secondary,
      padding: '0 8px',
    },
  };
};
